import { createFileRoute } from "@tanstack/react-router";
import AdminDemoPreview from "@/pages/admin/AdminDemoPreview";

export const Route = createFileRoute("/admin/demo")({ component: AdminDemoPreview });
